import axios from "./plugins/axios";

export default {
  // If this is the users OWN dashboard, then this will be empty,
  // and the API will by default return the users own website
  async getWebsite(websiteName) {
    const resp = await axios.get(`/monitor/${websiteName}`);
    console.log("GOT RESPONSE!");
    console.log(resp);
    return resp.data.data.website;
  },

  async auth() {
    const resp = await axios.get("/auth");
    return resp.data;
  }
};
